import {
  FETCH_DCM_LANDING_PAGES,
  ADD_CUSTOM_LANDING_PAGE,
  CLEAR_LANDING_PAGES
} from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";
import { normalizeDataByField } from "../utils/normalize";
import { landingPageScopeKey } from "../../utils/landingPages";

// `error` holds a message when the fetch fails so the URL dropdown can say so
// instead of looking like an empty list.
//
// `loadedKey` records which advertiser scope we last requested, so the fetch
// effect in CreativeNameGenerator can ask "have we tried this scope yet?"
// instead of "is the list empty?". Those are the same question only until you
// hit an advertiser that genuinely has no landing pages — it succeeds with
// `[]`, the old empty-list guard read that as a cold cache, and the effect
// refetched on every render forever.
const initialState = {
  isLoading: false,
  error: null,
  loadedKey: null,
  byId: {},
  allIds: []
};

export const dcmLandingPages = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DCM_LANDING_PAGES:
      switch (action.status) {
        case SUCCESS:
          let { byId, allIds } = normalizeDataByField(action.data, "id");
          return {
            isLoading: false,
            error: null,
            loadedKey: state.loadedKey,
            byId,
            allIds
          };
        case FAILURE:
          // Keep loadedKey: a failed scope counts as attempted, so the effect
          // stays parked and retry stays user-driven (the Retry link in the
          // dropdown) rather than becoming an endless retry loop.
          return {
            isLoading: false,
            error:
              (action.err && action.err.message) ||
              "Something went wrong loading URLs.",
            loadedKey: state.loadedKey,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        case PENDING: {
          let key = landingPageScopeKey(action.advertiserIds);
          // Switching advertisers invalidates the cache — don't leave the
          // previous advertiser's URLs selectable while the new list loads.
          // A retry of the same scope keeps what's there.
          let isSameScope = key === state.loadedKey;
          return {
            isLoading: true,
            error: null,
            loadedKey: key,
            byId: isSameScope ? { ...state.byId } : {},
            allIds: isSameScope ? [...state.allIds] : []
          };
        }
        default:
          return state;
      }
    case ADD_CUSTOM_LANDING_PAGE:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.landingPage.id]: {
            ...action.landingPage
          }
        },
        allIds: [...state.allIds, action.landingPage.id]
      };
    case CLEAR_LANDING_PAGES:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
